export default __webpack_public_path__ + "static/media/norris.2aacfdef.jpg";